"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styled_1 = require("./styled");
var Link = /** @class */ (function (_super) {
    __extends(Link, _super);
    function Link() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            selected: false
        };
        _this.handleKeyDown = function (e) {
            var event = e;
            if (event.keyCode === 91 || event.keyCode === 17) {
                _this.setState({
                    selected: true
                });
            }
        };
        _this.handleKeyUp = function () {
            _this.setState({
                selected: false
            });
        };
        return _this;
    }
    Link.prototype.componentDidMount = function () {
        window.document.addEventListener('keydown', this.handleKeyDown);
        window.document.addEventListener('keyup', this.handleKeyUp);
    };
    Link.prototype.componentWillUnmount = function () {
        window.document.removeEventListener('keydown', this.handleKeyDown);
        window.document.removeEventListener('keyup', this.handleKeyUp);
    };
    Link.prototype.render = function () {
        var _a = this.props, children = _a.children, contentState = _a.contentState, entityKey = _a.entityKey, onClick = _a.onClick, theme = _a.theme, anchorComponent = _a.anchorComponent, target = _a.target;
        var selected = this.state.selected;
        var AnchorComp = anchorComponent || styled_1.Anchor;
        var entity = contentState.getEntity(entityKey);
        var url = entity && entity.getData().url || '';
        return theme
            ? React.createElement("a", { href: url, target: target || '_blank', onClick: function (e) { return onClick && onClick(e, url); }, className: theme.anchor + (selected ? ' ' + theme.anchorSelect : '') }, children)
            : React.createElement(AnchorComp, { href: url, target: target || '_blank', onClick: function (e) { return onClick && onClick(e, url); }, modifierKeyDown: selected }, children);
    };
    return Link;
}(React.Component));
exports.default = Link;
